import { render, staticRenderFns } from "./_studentInfo.vue?vue&type=template&id=61723b63&scoped=true"
import script from "./_studentInfo.vue?vue&type=script&lang=js"
export * from "./_studentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61723b63",
  null
  
)

export default component.exports